var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"},{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"right-panel d-flex flex-column"},[_c('map-alerts',{staticClass:"mb-2"}),_c('item-information',{staticClass:"mb-2"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }